/**
 * Vote Calculation Toggle
 * Differentiates between Vote Share (votes cast/total votes) and Turnout Percent (votes cast/total registered)
 * Introduces a new QueryParam called calc_type that can be either: `voteShare` or `turnoutPercent`
 * For this to work make sure you:
 *  1. Add calc_type as queryParam in the election module (e.g. g2024.js) like so:
 *      calc_type: withDefault(StringParam, CALC_TYPE.VOTE_SHARE)
 *  2. Add REGISTERED_COUNT_PREFIX to the COUNT_PREFIXES in the corresponding config module (e.g. config.js):
 *      const REGISTERED_COUNT_PREFIX = "registered_count_";
 *
 * See https://targetsmart.atlassian.net/browse/SE-789
 *
 */

import React from "react";
import {
  BooleanParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import { CALC_TYPE } from "../helpers/config";

const VoteCalculationToggle = () => {
  let [query, setQuery] = useQueryParams({
    calc_type: withDefault(StringParam, CALC_TYPE.VOTE_SHARE),
    vote_mode: withDefault(BooleanParam, false),
  });

  let { calc_type, vote_mode } = query;

  return (
    !vote_mode && (
      <fieldset className={"d-flex"}>
        <legend>Vote Calculation</legend>
        <div>
          <button
            type="button"
            onClick={() => {
              setQuery({ calc_type: CALC_TYPE.VOTE_SHARE });
            }}
            className={`button ${calc_type === CALC_TYPE.VOTE_SHARE ? "selected" : "unselected"}`}
          >
            Vote Share
          </button>
          <button
            type="button"
            onClick={() => {
              setQuery({ calc_type: CALC_TYPE.TURNOUT_PERCENT });
            }}
            className={`button ${calc_type === CALC_TYPE.TURNOUT_PERCENT ? "selected" : "unselected"}`}
          >
            Turnout %
          </button>
        </div>
      </fieldset>
    )
  );
};

export default VoteCalculationToggle;
